
export default function DesignCardPreview({ title, description, children, onEdit, icon }) {
  return (
    <div className="bg-gray-100 rounded-2xl p-4 shadow-sm flex flex-col justify-between">
      <div className="mb-4 ">
        <div className="flex items-center gap-2 mb-2">
          <h3 className="font-semibold text-gray-900 text-xl">{title}</h3>
        </div>
        <p className="text-md text-gray-600">{description}</p>
      </div>

      {/* Preview Area */}
      <div className="flex items-end justify-between mt-10">
        <div className="flex rounded-full items-end justify-end">
          {/* Si no hay imagen, mostrar el placeholder */}
          {children ? (
            children
          ) : (
            <img
              src="/images/placeholder.png"
              alt="placeholder"
              className="h-20 w-20 object-contain opacity-60"
            />
          )}
        </div>

        {/* Edit Button */}
        <div>
            <button
              type="button"
              onClick={onEdit}
              className="cursor-pointer ml-4 px-3 py-1 rounded-xl bg-white text-gray-900 text-md hover:bg-gray-50 transition-colors"
            >
              Edit
            </button>
        </div>
      </div>
    </div>
  );
}
